import React from 'react';

function Skills() {
  return (
    <section className="skills">
      <h2>Skills</h2>
      <ul>
        <li>Python (NumPy, Pandas, Scikit-learn, TensorFlow)</li>
        <li>Machine Learning & Deep Learning</li>
        <li>AWS</li>
        <li>Tableau</li>
        <li>React, HTML, CSS, JavaScript</li>
        <li>APIs & Flask</li>
        <li>Problem Solving & Critical Thinking</li>
        <li>Version Control (Git & GitHub)</li>
      </ul>
    </section>
  );
}

export default Skills;
